// collection/item views for generic user list (based off of old LikersList view/collection)
GP.views.UserListItem = Backbone.Marionette.ItemView.extend({
    template: function(serialized_data) {
        var _template = 'user-row';

        return template(_template, serialized_data);
    },
    initialize:function() {

    },
    className: 'user-row clearfix',
    tagName: 'li',
    attributes: function() {
        var self = this;
        return {

        };
    },
    templateHelpers: function() {
        var self = this;

        return {
            profile_url: function() {
                return GP.Util.clean_url('/members/user/profile/', { duid: self.model.get('duid') });           
            }
        };
    },
    serializeData: function() {
        // overwritten function for passing custom data to handlebars template
        var data = {};
        data = {
            user: this.model.toJSON()
        };
        return data;
    },
    ui: {

    },
    events: {

    },
    onRender: function() {

    },

});

GP.views.UserList = Backbone.Marionette.CollectionView.extend({
    childView: GP.views.UserListItem,
    tagName: 'ul',
    className: 'generic-user-list list-unstyled'
});
